// extracted by mini-css-extract-plugin
export var avatar = "_p4-3";
export var avatarContainer = "_p4-2";
export var avatarSpacer = "_p4-5";
export var avatarSpacerContainer = "_p4-4";
export var avatarStackContainer = "_p4-1";
export var bubble = "_p4-0";
export var remainderBubble = "_p4-6";